import { defineMessages } from 'react-intl';
import type { ProductExpertiseEnum } from '@foundershub/api-client';

export const productExpertiseLabels = defineMessages<ProductExpertiseEnum>({
  net: {
    defaultMessage: '.NET',
    description: 'product expertise category label',
  },
  appsource: {
    defaultMessage: 'AppSource',
    description: 'product expertise category label',
  },
  azure: {
    defaultMessage: 'Azure',
    description: 'product expertise category label',
  },
  'azure-marketplace': {
    defaultMessage: 'Azure Marketplace',
    description: 'product expertise category label',
  },
  'dynamics-365': {
    defaultMessage: 'Dynamics 365',
    description: 'product expertise category label',
  },
  gaming: {
    defaultMessage: 'Gaming',
    description: 'product expertise category label',
  },
  github: {
    defaultMessage: 'GitHub',
    description: 'product expertise category label',
  },
  linkedin: {
    defaultMessage: 'LinkedIn',
    description: 'product expertise category label',
  },
  'microsoft-365': {
    defaultMessage: 'Microsoft 365',
    description: 'product expertise category label',
  },
  'microsoft-edge': {
    defaultMessage: 'Microsoft Edge',
    description: 'product expertise category label',
  },
  'power-apps': {
    defaultMessage: 'Power Apps',
    description: 'product expertise category label',
  },
  'power-automate': {
    defaultMessage: 'Power Automate',
    description: 'product expertise category label',
  },
  'power-bi': {
    defaultMessage: 'Power BI',
    description: 'product expertise category label',
  },
  sharepoint: {
    defaultMessage: 'SharePoint',
    description: 'product expertise category label',
  },
  teams: {
    defaultMessage: 'Teams',
    description: 'product expertise category label',
  },
  'visual-studio': {
    defaultMessage: 'Visual Studio',
    description: 'product expertise category label',
  },
  windows: {
    defaultMessage: 'Windows',
    description: 'product expertise category label',
  },
});
